import { createPortal } from "react-dom";

function Timer({ remaining, total, container }) {
  if (!remaining || !total || !container) return null;
  return createPortal(<></>, container);
}

export default Timer;
